@let objects = objectsList();
@let selected = selectedObjects();
@if (objects && objects.length > 0) {
  <div data-id="objects-list">
    @for (object of objects; track object.id) {
      <div
        [attr.data-id]="'object-' + object.id"
        class="flex flex-row justify-between items-center gap-x-3 h-10"
      >
        @if (showCheckboxes()) {
          <p-checkbox
            [attr.data-id]="'object-checkbox-' + object.id"
            [value]="object"
            [ngModel]="selected"
            [disabled]="true"
            checkboxIcon="ui-check"
            [inputId]="'object-checkbox-' + object.id"
          ></p-checkbox>
        }
        <label
          [attr.for]="'object-checkbox-' + object.id"
          class="bd-body-regular grow"
          >{{ object.name }}</label
        >
      </div>
    }
  </div>
}
